import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trim',
})
export class TrimPipe implements PipeTransform {
  // Par défaut, ce pipe va enlever les espaces et les virgules au début et à la fin de la chaîne de caractères
  // Mais on peut très bien lui passer un deuxième argument pour lui dire quels caractères on veut enlever
  transform(value: string, chars: string = ', '): string {
    if (!value) return value;

    let start = 0;
    let end = value.length;

    // Trimmer au début
    while (start < end && chars.indexOf(value[start]) >= 0) {
      start++;
    }

    // Trimmer à la fin
    while (end > start && chars.indexOf(value[end - 1]) >= 0) {
      end--;
    }

    return start > 0 || end < value.length
      ? value.substring(start, end)
      : value;
  }
}
